import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets scroll to top on every route change.
 * Skips scroll if the URL has a hash (so section anchors still work).
 */
export default function ScrollToTop() {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (hash) return;
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname, hash]);

    return null;
}
